/* If browser back button was used, flush cache */
(function () {
	window.onpageshow = function(event) {
		if (event.persisted) {
			$.ajax({
    type: 'GET',
    url: 'https://mymotive.com/cart.json',
    dataType: 'json',
    success: function(data) { 
        var item_count = data.item_count;
$(".cart-item-count-header--quantity").text(item_count);
         if ( item_count > 0) {
      $(".cart-item-count-header--quantity").removeClass("hide");
         }
     else {
        $(".cart-item-count-header--quantity").addClass("hide");
     }
    }
});
		}
	};
})();

$(document).ready(function(){
    $(".card").click(function(){
     $(".card").removeClass("active");
     $(".hidemec").hide(); 
    $(this).addClass("active");
   $(this).closest('.scene').find('#cccccc').show(); 
  });

  $(".hidemec").click(function(){
    $(this).closest('.scene').find('#ddd').removeClass("active");
     $(this).hide();
  });

     if(window.location.href == 'https://mymotive.com/pages/contact-us'){    
    $("body").addClass('contact_motive');
    
}
    
    if(window.location.href == 'https://mymotive.com/pages/contact-us?_pos=1&_psq=contact&_ss=e&_v=1.0'){    
    $("body").addClass('contact_motive');
    
}
  
    $('.show_more a#s-a4fdb8d4-b3ea-4a47-9ac7-e9457557dd3a').click(function(e) {
			 e.preventDefault();
			 
			 $('.clinical_show').slideToggle();

			 $(this).text($(this).text() == 'Show less' ? 'Show more' : 'Show less');
        });
  
  $('.No_space').keypress(function( e ) {    
    if(!/[0-9a-zA-Z-]/.test(String.fromCharCode(e.which)))
        return false;
});


if ($(window).width() < 900) {
  $(document).ready(function(){
    $('.outerclass90daysminimodulebuttonclass').slick({
  dots: false,
   arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  responsive: [

    {
      breakpoint: 1024,
      settings: {
        dots: false,
   arrows: true,
        slidesToShow: 4,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
         dots: false,
        arrows: true,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
         dots: false,
        arrows: true,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
    
    }); 
}

  
  $(".tav1cl").mouseenter(function(){
    $(this).addClass("active");
    $(".tav2cl").removeClass("active");
     $(".tav3cl").removeClass("active");
      $(".tav4cl").removeClass("active");
       $(".tav5cl").removeClass("active");
  });
  
    $("tav1cl").mouseleave(function(){
    $(this).addClass("active");
  });
  
  
  $("tav1c2").mouseleave(function(){
    $(this).addClass("active");
  });
  
    $("tav3cl").mouseleave(function(){
    $(this).addClass("active");
  });
  
    $("tav4cl").mouseleave(function(){
    $(this).addClass("active");
  });
  
    $("tav5cl").mouseleave(function(){
    $(this).addClass("active");
  });
  
  
  

  $(".tav2cl").mouseenter(function(){
    $(this).addClass("active");
    $(".tav1cl").removeClass("active");
     $(".tav3cl").removeClass("active");
      $(".tav4cl").removeClass("active");
       $(".tav5cl").removeClass("active");
  });
  
    $(".tav3cl").mouseenter(function(){
    $(this).addClass("active");
    $(".tav2cl").removeClass("active");
     $(".tav1cl").removeClass("active");
      $(".tav4cl").removeClass("active");
       $(".tav5cl").removeClass("active");
  });
  
    $(".tav4cl").mouseenter(function(){
    $(this).addClass("active");
    $(".tav2cl").removeClass("active");
     $(".tav3cl").removeClass("active");
      $(".tav1cl").removeClass("active");
       $(".tav5cl").removeClass("active");
  });
  
    $(".tav5cl").mouseenter(function(){
    $(this).addClass("active");
    $(".tav2cl").removeClass("active");
     $(".tav3cl").removeClass("active");
      $(".tav4cl").removeClass("active");
       $(".tav1cl").removeClass("active");
  });
});


$(document).mouseup(function (e) {
  var container = $(".modal-content");

  // if the target of the click isn't the container nor a descendant of the container

  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $(".modal-header .close").trigger("click");
    $("video#data1").trigger("pause");
    $("video#data2").trigger("pause");
    $("video#data3").trigger("pause");
    $("video#heroVideonew").trigger("pause");
    $("video#datanew").trigger("pause");
    $("video#heroVideotwo").trigger("pause");
    $("video#heroVideothree").trigger("pause");
    $("video#heroVideofour").trigger("pause");

    var src1= $("iframe#iframe1").attr('src');
    $("iframe#iframe1").attr('src',src1);  
   
    var src2= $("iframe#iframe2").attr('src');
    $("iframe#iframe2").attr('src',src2);  
    
     var src3= $("iframe#iframe3").attr('src');
    $("iframe#iframe3").attr('src',src3);  

    var src4= $("iframe#product_video4").attr('src');
    $("iframe#product_video4").attr('src',src4);  
   
    var src5= $("iframe#product_video2").attr('src');
    $("iframe#product_video1").attr('src',src5);  
    
     var src6= $("iframe#product_video3").attr('src');
    $("iframe#product_video3").attr('src',src6);  
      
  }
});

//toggle event for read more link
function toggleContent(event) {
      event.preventDefault();
      var moreContent = document.querySelector('.content .more-content');
      var readMoreButton = document.querySelector('.content .read-more');
      var secondLine = document.querySelector("#secondLine");
   
      
      moreContent.classList.toggle('show');
      readMoreButton.classList.toggle('show');
    
      
      if (moreContent.classList.contains('show')) {
        readMoreButton.textContent = "Read Less";        
      } else {
        readMoreButton.textContent = "Read More";

        
      }
    }

// for cart page max order
$(document).ready(function () {
   setTimeout(function () {
        }, 200);
  $(".extraclasshide").show();
  if ($(window).width() < 767) {
    // var urlforposter = $(".extraclasshide").attr("postermobile");
    // $("#top_video").attr("poster", urlforposter);
    // $(".extraclasshide").show();
  }

  $(".modal-header .close").click(function () {
    $("video#data1").trigger("pause");
    $("video#data2").trigger("pause");
    $("video#data3").trigger("pause");
    $("video#heroVideonew").trigger("pause");
    $("video#datanew").trigger("pause");
    $("video#heroVideotwo").trigger("pause");
    $("video#heroVideothree").trigger("pause");
    $("video#heroVideofour").trigger("pause");

    var src4= $("iframe#product_video4").attr('src');
    $("iframe#product_video4").attr('src',src4);  
   
    var src5= $("iframe#product_video2").attr('src');
    $("iframe#product_video1").attr('src',src5);  
    
    var src6= $("iframe#product_video3").attr('src');
    $("iframe#product_video3").attr('src',src6);   
    
  });

});

$(document).ready(function () {
  var numItems = $(".buttoncommanclassbubble").length;
  if (numItems > 4) {
    $(".outerclass90daysminimodulebuttonclass").addClass("bubblecount4");
  } else {
    $(".outerclass90daysminimodulebuttonclass").addClass("bubblecount5");
  }
});

$(document).mouseup(function (e) {
  var container = $(".site-nav");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    if ($("body").hasClass("nav-active")) {
      // $(".nav-hover2").trigger('click');
      $(".site-nav--has-dropdownshowmotivemainbold").removeClass("nav-hover2");
      //$("span.icon-dropdown.shop_icon").css("rotate", "0deg");
      $("span.icon-dropdown.shop_icon").css("transform", "rotateX(0deg)");
    }
  }
});

$(document).mouseup(function (e) {
  var container = $(".site-nav");

  // if the target of the click isn't the container nor a descendant of the container

  if (!container.is(e.target) && container.has(e.target).length === 0) {
    if ($("body").hasClass("nav-active")) {
      $(".site-nav--has-dropdownexplore").removeClass("nav-hover2");
      $("span.icon-dropdown.explore_icon").css("transform", "rotateX(0deg)");
    }
  }
});

$(document).ready(function () {
  $("#top_video").on("ended", function () {
    jQuery(".extraclasshide .playtwo").show();
    jQuery(".extraclasshide .pausetwo").hide();
  });

  var cookies = document.cookie.split("; ");
  for (var i = 0; i < cookies.length; i++) {
    var parts = cookies[i].split("=");
    var name = parts[0];
    var value = parts[1];
    if (name === "mutlipass_auth0") {
      // console.log("The value of myCookie is " + value);
    }
  }

  $(".destopform").click(function () {
    $(".address_div").toggleClass("showthisd");
  });

  $(".cacelformdesf").click(function () {
    $(".address_div").removeClass("showthisd");
  });

  $(function () {
    if ($("div").hasClass("recharge-te")) {
      $("body").addClass("remove_footer_background");
    }
  });

  $(".customer-journey-ul").slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          dots: false,
          arrows: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
        },
      },

      {
        breakpoint: 900,
        settings: {
          dots: false,
          arrows: false,
          slidesToShow: 2,
          margin: 15,
          slidesToScroll: 1,
          infinite: false,
        },
      },

      {
        breakpoint: 600,
        settings: {
          dots: false,
          arrows: false,
          margin: 10,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 500,
        settings: {
          dots: false,
          arrows: true,
          margin: 10,
          slidesToShow: 1,
          prevArrow:
            "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
          nextArrow:
            "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
});

/* Change status according to Fulfill */
$(".imageclassmovcomman").click(function () {
  var idbutton2 = $(this).attr("id");
  var classname22 = "." + idbutton2 + "content";
  $(".comaanclassforcntent").hide();
  $(".imageclassmovcomman").removeClass("activec");
  $(classname22).fadeIn();
  $(".imageclassmovcomman").css("opacity", "0.5");

   if ($('.ineeerextrscl').hasClass('hidethisdiv')){
     $(".hidethisdiv").css("display","none");
     $(".imageclassmovcomman").css("opacity", "1");
   }
  else{
     
     $(this).addClass("activec");
  }
  
  

});
$(".hidemvf").click(function () {
  $(".imageclassmovcomman").css("opacity", "1");
  $(".imageclassmovcomman").removeClass("activec");
  $(this).closest(".comaanclassforcntent").fadeOut();
});

$(document).ready(function () {

  $(function () {
    if ($(".extraclassnewsletter").hasClass("bottomremove")) {
      $("body").addClass("removegapfooter");
    }
  });

  $(function () {
    $(".shg-sld-item:first").hasClass("shg-sld-active");
    //$(".shg-sld-left").addClass("fadeddd");
  });

  $(".shg-sld-nav-button").click(function () {
    setInterval(function () {
      if (
        $(".shg-sld-item.animate__animated.animate__:last").hasClass(
          "shg-sld-active"
        )
      ) {
     //   $(".shg-sld-right").addClass("fadeddd");
      } else {
     //   $(".shg-sld-right").removeClass("fadeddd");
      }
    }, 500);
  });

  $(".shg-sld-nav-button").click(function () {
    setInterval(function () {
      if ($(".shg-sld-item:first").hasClass("shg-sld-active")) {
    //    $(".shg-sld-left").addClass("fadeddd");
      } else {
      //  $(".shg-sld-left").removeClass("fadeddd");
      }
    }, 500);
  });

  $(".sliderclassextra .slick-next.slick-arrow").click(function () {
    setInterval(function () {
      if (
        $(".slick-active .buttoncommanclassbubble").hasClass("activecolorcolor")
      ) {
      } else {
        $(".slick-current .buttoncommanclassbubble").trigger("click");
      }
    }, 500);
  });

  $(".sliderclassextra .slick-prev.slick-arrow").click(function () {
    if (
      $(".slick-active .buttoncommanclassbubble").hasClass("activecolorcolor")
    ) {
    } else {
      $(".slick-active .buttoncommanclassbubble").last().trigger("click");
    }
  });

  $(".nextarrowsforyt").click(function () {
    $("#pagin2 li:nth-last-child(2) a").trigger("click");
  });

  setInterval(function () {
    $("#pagin2 li:nth-last-child(2) a").click(function () {
      $(".prevarrowsforyt").removeClass("fadingthisvv");
      $(".nextarrowsforyt").addClass("fadingthisvv");
    });

    $("#pagin2 li:nth-child(2) a").click(function () {
      $(".nextarrowsforyt").removeClass("fadingthisvv");
      $(".prevarrowsforyt").addClass("fadingthisvv");
    });

    if ($("#pagin2 li:nth-child(2) a").hasClass("current")) {
      $(".prevarrowsforyt").addClass("fadingthisvv");
    }
  }, 1000);

  $(".prevarrowsforyt").click(function () {
    $("#pagin2 li:nth-child(2) a").trigger("click");
  });

  var pageURL = $(location).attr("host");
  //alert(pageURL);

  $(".newmobile").hide();
  $("#showbtn").click(function () {
    $(".newmobile").toggle();
  });

  $(".showbtn_last").click(function () {
    $(".newmobile").toggle();
  });

  $("#dynamic-select").bind("change", function () {
    // bind change event to select
    var url = $(this).val(); // get selected value
    if (url != "") {
      // require a URL
      window.location = url; // redirect
    }
    return false;
  });

 $(".phone_class").keyup(function () {
    var maxChars = 10;
    if ($(this).val().length > maxChars) {
      $(this).val($(this).val().substr(0, maxChars));
    }
  }); 

  $(".address_pin").keyup(function () {
    var maxCharss = 6;
    if ($(this).val().length > maxCharss) {
      $(this).val($(this).val().substr(0, maxCharss));
    }
  });
});

if ($(window).width() < 1270) {
  $(document).ready(function () {
    $(".slidercl2").slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1271,
          settings: {
            dots: false,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            dots: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 500,
          settings: {
            dots: false,
            arrows: true,
            prevArrow:
              "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
            nextArrow:
              "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });
  });
}



$(document).ready(function () {
  $("#ORDER_HISTORY").css({ display: "block" });
  $("#first_tab").addClass("active");
});

jQuery(".data-driven-tab li").hover(function () {
  var tab = jQuery(this).data("tab");
  jQuery(".tab-content").hide();
  jQuery("." + tab).show();
});
jQuery(document).ready(function () {

  $(".site-nav--has-dropdown.mega-menu").mouseenter(function () {
    $("body").addClass("dropdownactive");
  });

  $(".site-nav--has-dropdown.mega-menu").mouseleave(function () {
    $("body").removeClass("dropdownactive");
  });

  if ($(window).width() < 900) {
    $(document).ready(function () {
      $(".press-column .shg-row:first").slick({
        dots: true,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              dots: true,
              arrows: true,
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              dots: true,
              arrows: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              dots: true,
              arrows: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ],
      });

      $(".simple-selling-point .shg-row:first").slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        centerMode: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              dots: false,
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              dots: false,
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 550,
            settings: {
              dots: false,
              arrows: true,
              slidesToShow: 1,
              prevArrow:
                "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
              nextArrow:
                "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
              slidesToScroll: 1,
            },
          },
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ],
      });
      $(".featured-in-items .shg-row:first").slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              dots: false,
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              dots: false,
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              dots: false,
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ],
      });

    //   $(".slide").slick({
    //     dots: false,
    //     arrows: false,
    //     infinite: false,
    //     speed: 300,
    //     centerMode: true,
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     responsive: [
    //       {
    //         breakpoint: 1024,
    //         settings: {
    //           dots: false,
    //           arrows: false,
    //           slidesToShow: 2,
    //           slidesToScroll: 1,
    //           infinite: true,
    //         },
    //       },
    //       {
    //         breakpoint: 540,
    //         settings: {
    //           dots: false,
    //           arrows: false,
    //           slidesToShow: 2,
    //           slidesToScroll: 1,
    //         },
    //       },
    //       {
    //         breakpoint: 500,
    //         settings: {
    //           dots: false,
    //           arrows: true,
    //           slidesToShow: 1,
    //           prevArrow:
    //             "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    //           nextArrow:
    //             "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
    //           slidesToScroll: 1,
    //         },
    //       },
    //       // You can unslick at a given breakpoint now by adding:
    //       // settings: "unslick"
    //       // instead of a settings object
    //     ],
    //   });
    });
  }
});

$(document).ready(function () {
  $(function () {
    jQuery(".accordion.activepanelclass").trigger("click");
    $(".mainmobilesliderclass .slick-prev.slick-arrow").text("last");
  });
});



$(document).ready(function(){

$("div#s-81076f7b-10be-4c8e-a6c7-1a1b169a2358").attr("onclick","zE('messenger', 'open');");

 $("div#s-3c0947b4-86ee-4519-9e00-e65f1e772543").attr("onclick","location.href='mailto:support@mymotive.com'");

$("div#s-fd6a9494-0361-4a4d-9407-4bcd94b9dabb").attr("onclick","location.href='tel:+1-877-MOTIVE8'");

});


